/* Various */

export function capitalize(string) {
    return string[0].toUpperCase() + string.slice(1);
}


/* Cookies */

export function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        let cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

export function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + '; ' + expires;
}


/* Vue-filters */

export function telephoneFilter(value) {
    return value.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3');
}


export function dateFilter(value) {
    if (!value) return '';
    const date = moment(value, 'YYYY-MM-DD');
    // Capitalization occurs because moment.js library claims that capitalization
    // of weekdays, months and so on in polish is interestingly no good thing.
    return `${date.format('D')} ${capitalize(date.format('MMM'))} - ${capitalize(date.format('dddd'))}`;
}

export function timeFilter(value) {
    if (!value) return '';
    if (/^(\d{2}):(\d{2}):(\d{2})$/.test(value))
        return value.slice(0, value.length - 3);
    return value;
}


/* Validators */

export function isValidPhoneNumber(phone) {
    let isValid = true;
    phone = phone.replace(/\s|\(|\)|\-/g, '');
    let regex = /^\+[0-9]{1,4}[0-9]{5,}$/i;
    isValid = regex.test(phone) && isValid;
    if (!isValid) {
        regex = /^[0-9]{9}$/i;
        isValid = regex.test(phone);
    }
    return isValid;
}

export function isValidEmail(email) {
    const regex = new RegExp([
        '^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.',
        '(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|',
        '([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$'
    ].join(''));
    return regex.test(email);
}


/* Time and date */

export function getCurrentDate(format=true) {
    const date = moment();
    
    return format ? date.format('YYYY-MM-DD') : date;
}

export function getCurrentTime(format=true) {
    const coeff = 15 * 60 * 1000;
    const time = moment(Math.ceil(moment() / coeff) * coeff);

    return format ? time.format('HH:mm') : time;
}


/* Debouncer */

import {
    TIMEOUTS
} from './constants.js'

let debouncerTimeout = null;

export function debounce(action, ...args) {
    if (debouncerTimeout) clearTimeout(debouncerTimeout);
    debouncerTimeout = setTimeout(() => action(...args), TIMEOUTS.DEBOUNCER);
}



// WEBPACK FOOTER //
// ./src/utils.js